module.exports = "mutation ($userId: String!) {\n    friendRemove(friendingUserId: $userId)\n}\n"